import {APIURL} from '../../constants';
import axios from 'axios';
import {translater} from '../../tools/translate';
import fileTools from '../../tools/files';


export default {
    namespaced: true,
    state: {

        audioTaskImageAnswerMimeTypes: {
            'image/png': ['png']
        },

        audioTaskAnswerImagesToUpload: {},

        /*paths: {
            6: 'images',
            4: 'audio',
            7: 'videos',
            12: '360videos',
            14: '360videos',
            15: 'images',
            17: 'videos'
        },*/

        validMimeTypes: {
            6: {
                mimeTypes: {
                    'image/jpeg': ['jpg', 'jpeg'],
                    'image/png': ['png']
                }
            },

            21: {
                mimeTypes: {
                    'image/jpeg': ['jpg', 'jpeg'],
                    'image/png': ['png']
                }
            },

            20: {
                mimeTypes: {
                    'image/jpeg': ['jpg', 'jpeg'],
                    'image/png': ['png']
                }
            },

            4: {
                mimeTypes: {
                    'audio/mp3': ['mp3'],
                    'audio/mpeg': ['mp3']
                }
            },

            7: {
                mimeTypes: {
                    'video/mp4': ['mp4']
                }
            },
            12: {
                mimeTypes: {
                    'video/mp4': ['mp4']
                }
            },
            14: {
                mimeTypes: {
                    'video/mp4': ['mp4']
                }
            },

            15: {
                mimeTypes: {
                    'image/jpeg': ['jpg', 'jpeg'],
                    'image/png': ['png']
                }
            },

            17: {
                mimeTypes: {
                    'video/mp4': ['mp4']
                }
            },
        },

        isUploading: false,
        filesToUpload: [],
        uploadedFiles: [],
        isCheckingIfExists: false,
        isRemoving: false

    },

    actions: {

        answerImageNumValidator(context, payload)
        {
            let valid = false;
            if(payload.length === 1)
            {
                valid = true;
            }

            return Promise.resolve(valid);
        },

        setSeason(context, payload) {

            context.commit('flushSeasonErrors');

            let found = context.state.filesToUpload.findIndex((f) => {
                return f.name == payload.f.name;
            })

            if (found > -1) {


                context.commit('setSeason', {found: found, c: payload.c})
                context.dispatch('setSeasonErrors');

            }


        },

        setSeasonErrors(context) {
            let duplicates = [];
            context.state.filesToUpload.forEach((f) => {
                let filtered = context.state.filesToUpload.filter((ftu) => {
                    return f.name !== ftu.name
                        && f.season.value === ftu.season.value
                })

                duplicates = duplicates.concat(filtered)
            })


            context.commit('setSeasonErrors', duplicates)


        },

        // upload specific
        setFilesToUpload(context, payload) {
            context.commit('setFilesToUpload', payload)
        },

        cancelReplace(context, payload) {
            let cancelable = context.state.filesToUpload.findIndex((f) => {
                return f.name === payload.name
            })

            if (cancelable > -1) {
                context.commit('remove', {i: cancelable})
            }

        },

        remove(context, payload) {
            context.commit('setIsRemoving', true)
            let t = context.rootGetters['checkpoints/newTask'];


            axios.put(APIURL + 'checkpoints/remove',
                {
                    filename: payload.name,
                    dir: context.rootGetters['routes/route'].name,
                    type: t.type
                })
                .then(() => {


                    if (typeof t.answers !== 'undefined' &&
                        typeof t.answers[payload.name] !== 'undefined') {

                        context.commit('checkpoints/deleteAnswer', payload.name, {root: true})
                    } else {
                        //console.log("remove failed", t.answers[payload.name])
                    }


                    let i = context.state.filesToUpload.findIndex((f) => {
                        return f.name === payload.name && f.uploaded;
                    })

                    if (i > -1) {
                        context.commit('remove', {i: i})

                    }


                })
                .catch(() => {
                    //console.log(err);
                })
        },

        // upload specific
        replace(context, payload) {
            let newTask = context.rootGetters['checkpoints/newTask']
            if (typeof context.state.validMimeTypes[newTask.type] === 'undefined') {
                //console.error('Missing valid mimetype');
                return;
            }

            context.commit('setIsUploading', true)

            let validExtensions = [];
            //let validFiles = [];
            let uniqueExtensions = []


            let validMimeTypes = Object.keys(context.state.validMimeTypes[newTask.type].mimeTypes).map((mt) => {
                let exts = context.state.validMimeTypes[newTask.type]['mimeTypes'][mt];
                validExtensions = validExtensions.concat(exts);

                return mt;
            })

            validExtensions.forEach((ve) => {
                let i = uniqueExtensions.findIndex((ue) => {
                    return ue == ve;
                })

                if (i == -1) {
                    uniqueExtensions.push(ve);
                }
            })

            validExtensions = uniqueExtensions;


            let foundMimetype = validMimeTypes.find((t) => {
                return t === payload.type;
            })


            let existingFileIndex = context.state.filesToUpload.findIndex((f) => {
                return f.name === payload.name && typeof f.error === 'undefined';
            })

            if (existingFileIndex > -1) {

                context.commit('remove', {i: existingFileIndex});
            }


            if (!foundMimetype) {
                payload.error = {
                    text: context.rootGetters['translate/translater']
                        .__('Only valid filetypes are {0}',
                            'fileErrors',
                            validExtensions.join(', ')
                        ), type: 'filetype'
                }
            }


            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'authorization': localStorage.getItem('authorization')
                },

                onUploadProgress: (e) => {
                    let progress = e.loaded / e.total * 100;
                    progress = parseInt(progress);
                    payload.progress = progress;

                    //window.vm.$emit('uploadProgress');

                }


            };

            let data = new FormData();
            data.append('file', payload)
            data.append('dir', context.rootGetters['routes/route'].name);
            data.append('type', context.rootGetters['checkpoints/newTask'].type);


            axios.post(APIURL + 'checkpoints/upload', data, config)
                .then((res) => {

                    context.dispatch('setFileUploaded', res.data)
                    context.commit('setIsUploading', false)
                    context.dispatch('status/updateResources', 'files', {root: true})


                })
                .catch(() => {
                    //console.log("err", err)

                })
        },

        uploadAudioTaskAnswerImage(context, payload) {



            payload.image = payload.files[0]
            payload.changeName = false

            //console.log("##### uploadAudioTaskAnswerImage", payload)
            let validExtensions = [];
            if (typeof context.state.audioTaskImageAnswerMimeTypes[payload.image.type] === 'undefined') {
                //console.error('Missing valid mimetype');
                let mimeTypes = Object.keys(context.state.audioTaskImageAnswerMimeTypes).map((mt) => {
                    return mt;
                });
                mimeTypes.forEach((mt) => {
                    validExtensions = validExtensions.concat(context.state.audioTaskImageAnswerMimeTypes[mt]);
                });

                payload.image.error = {
                    text: context.rootGetters['translate/translater']
                        .__('Only valid filetypes are {0}',
                            'fileErrors',
                            validExtensions.join(', ')
                        ), type: 'filetype'
                }

            }

            context.commit('setAudioTaskAnswerImageToUpload', payload)

            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'authorization': localStorage.getItem('authorization')
                },
                onUploadProgress: (e) => {
                    let progress = e.loaded / e.total * 100;
                    progress = parseInt(progress);
                    payload.image.progress = progress;

                    //window.vm.$emit('uploadAudioTaskAnswerImageProgress');
                }


            };


            if (typeof payload.image.error === 'undefined') {

                context.commit('setIsUploading', true)
                let data = new FormData();
                //payload.image.name = new Date().getTime();
                data.append('file', payload.image)
                data.append('dir', context.rootGetters['routes/route'].name)
                data.append('type', 6);
                data.append('change_name', payload.changeName)
                axios.post(APIURL + 'checkpoints/upload', data, config)
                    .then((res) => {
                        //console.log("########## res.data", res.data)
                        context.commit('setIsUploading', false)
                        context.commit('setAudioTaskImageUploaded', payload.audio);
                        context.dispatch('setMatchingImageForAudio', {file: payload.audio, image: res.data})
                        context.dispatch('setUploadImageAnswer', {file: {name: payload.audio}, value: false})
                        //window.vm.$emit('fileUploaded')
                        context.dispatch('status/updateResources', 'files', {root: true})
                    })
                    .catch(() => {
                        console.log("upload::err", err)
                    })
            }


        },

        // upload specific
        uploadAudioTaskAnswerImageEdit(context, payload) {

            let validMimeTypes = Object.keys(context.state.validMimeTypes[6].mimeTypes).map((mt) => {
                return mt;
            })

            console.log(validMimeTypes)

            context.dispatch('uploadEdit', {
                files: payload,
                replaceMethod: 'checkpoints/replaceUploadedAudioTaskImage',
                validMimeTypes: validMimeTypes,
                type: 6
            });
        },
        // upload specific
        /*uploadEdit(context, payload)
        {
            let t = context.state.editableTask;
            if(typeof payload.files === 'undefined')
            {
                payload.files = payload;
            }

            if(typeof context.state.validMimeTypes[t.type] === 'undefined')
            {
                console.error('Missing valid mimetype');
                return;
            }

            context.commit('setIsUploading', true)

            let validExtensions = [];
            let validFiles = [];
            let uniqueExtensions = [];
            let validMimeTypes = payload.validMimeTypes;

            if(typeof validMimeTypes === 'undefined')
            {
                validMimeTypes = Object.keys(context.state.validMimeTypes[t.type].mimeTypes).map((mt) => {
                    let exts = context.state.validMimeTypes[t.type]['mimeTypes'][mt];
                    validExtensions = validExtensions.concat(exts);

                    return mt;
                })
            }

            validExtensions.forEach((ve) => {
                let i = uniqueExtensions.findIndex((ue) => {
                    return ue == ve;
                })

                if(i == -1)
                {
                    uniqueExtensions.push(ve);
                }
            })

            validExtensions = uniqueExtensions;

            payload.files = Array.from(payload.files);
            payload.files.forEach((f) => {

                let foundMimetype = validMimeTypes.find((t) => {
                    return t === f.type;
                })

                let duplicate = context.state.filesToUpload.find((ftu) => {
                    return f.name === ftu.name;
                })

                if(duplicate)
                {
                    f.error = {
                        text:context.rootGetters['translate/translater']
                        .__('File already exists', 'fileErrors'), type: 'duplicate'}
                }

                if(!foundMimetype){
                    f.error = {text:context.rootGetters['translate/translater']
                    .__('Only valid filetypes are {0}',
                        'fileErrors',
                        validExtensions.join(', ')
                    ), type: 'filetype'}
                }



            })

            let hasError = payload.files.find((file) => {
                return typeof file.error !== 'undefined'
            })

            if(hasError)
            {
                context.commit(
                    'checkpointsValidator/setValidEdit', false, {root: true});
            }





            context.commit('setFilesToUpload', payload.files)
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'authorization': localStorage.getItem('authorization')
                },




            };



            payload.files.forEach((f, i) => {


                config.onUploadProgress = (e) => {
                    let progress = e.loaded / e.total * 100;
                    progress = parseInt(progress);
                    f.progress = progress;

                    //window.vm.$emit('uploadProgress');

                }
                if(typeof f.error === 'undefined')
                {
                    let data = new FormData();
                    data.append('file', f)
                    data.append('dir', context.rootGetters['routes/route'].name)
                    data.append('type', t.type);
                    axios.post(APIURL + 'checkpoints/upload', data, config)
                    .then((res) => {



                        //context.commit('addAnswerEdit', res.data);
                        context.commit('addUploadedFile', res.data)



                        if(context.state.uploadedFiles.length >= payload.length)
                        {
                            context.commit('setIsUploading', false)
                            //context.commit('flushFilesToUpload');
                        }



                        context.dispatch('setFileUploaded', res.data)

                        if(typeof payload.replaceMethod === 'undefined'){
                            context.dispatch('checkpoints/replaceUploadedFile', f.name, {root: true});
                        } else {
                            console.log(payload.replaceMethod)
                            context.dispatch(payload.replaceMethod, f.name, {root: true});
                        }



                    })
                    .catch((err) => {
                        console.log("err", err)
                    })
                }
            })





        }, */

        setUploadImageAnswer(context, payload) {

            let i = context.state.filesToUpload.findIndex((f) => {
                return f.uploaded === true && f.name === payload.file.name;
            })

            if (i > -1) {
                context.commit('setUploadImageAnswer', {i: i, value: payload.value})
            }


        },

        setMatchingImageForAudio(context, payload) {
            let uploaded = context.state.filesToUpload.findIndex((f) => {
                return f.name === payload.file
            });

            if (uploaded > -1) {
                context.commit('setMatchingImageForAudio', {i: uploaded, image: payload.image})

            }
        },

        // upload specific
        fileExists(context, payload) {
            context.commit('setIsCheckingIfExists', true)
            let name = payload;
            payload = {
                name: name,
                route: context.rootGetters['routes/route'].name,
                dir: context.rootGetters['checkpoints/paths'][6]
            }

            return axios.post(APIURL + 'checkpoints/imageExists', payload)

        },

        uploadAudio(context, payload) {
            let newTask = context.rootGetters['checkpoints/newTask'];
            if (typeof context.state.validMimeTypes[newTask.type] === 'undefined') {
                //console.error('Missing valid mimetype');
                return;
            }

            context.commit('setIsUploading', true);

            let validExtensions = [];
            //let validFiles = [];
            let uniqueExtensions = [];
            let validMimeTypes = Object.keys(context.state.validMimeTypes[newTask.type].mimeTypes).map((mt) => {
                let exts = context.state.validMimeTypes[newTask.type]['mimeTypes'][mt];
                validExtensions = validExtensions.concat(exts);

                return mt;
            })

            validExtensions.forEach((ve) => {
                let i = uniqueExtensions.findIndex((ue) => {
                    return ue == ve;
                })

                if (i === -1) {
                    uniqueExtensions.push(ve);
                }
            })

            validExtensions = uniqueExtensions;

            payload = Array.from(payload);
            payload.forEach((f) => {

                let foundMimetype = validMimeTypes.find((t) => {
                    return t === f.type;
                })

                let duplicate = context.state.filesToUpload.find((ftu) => {
                    return f.name === ftu.name;
                })

                if (duplicate) {
                    f.error = {
                        text: context.rootGetters['translate/translater']
                            .__('File already exists', 'fileErrors'), type: 'duplicate'
                    }
                }

                if (!foundMimetype) {
                    f.error = {
                        text: context.rootGetters['translate/translater']
                            .__('Only valid filetypes are {0}',
                                'fileErrors',
                                validExtensions.join(', ')
                            ), type: 'filetype'
                    }
                }


            })


            context.commit('setFilesToUpload', payload)
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'authorization': localStorage.getItem('authorization')
                },


            };


            payload.forEach((f) => {


                config.onUploadProgress = (e) => {
                    let progress = e.loaded / e.total * 100;
                    progress = parseInt(progress);
                    f.progress = progress;

                    //window.vm.$emit('uploadProgress');

                }
                if (typeof f.error === 'undefined') {
                    let data = new FormData();
                    data.append('file', f)
                    data.append('dir', context.rootGetters['routes/route'].name)
                    data.append('type', newTask.type);
                    axios.post(APIURL + 'checkpoints/upload', data, config)
                        .then((res) => {


                            //console.log(res.data)

                            context.commit('checkpoints/addAnswer', res.data, {root: true});
                            context.commit('addUploadedFile', res.data)


                            if (context.state.uploadedFiles.length >= payload.length) {
                                context.commit('setIsUploading', false)
                                //context.commit('flushFilesToUpload');
                            }

                            //if(context.state.newTask.type == 4)
                            //{
                            //console.log("############ upload audio", res.data);
                            context.dispatch('fileExists', res.data)

                                .then((existsRes) => {
                                    //console.log("hep exists", existsRes.data)
                                    context.commit('setIsCheckingIfExists', false)
                                    if (existsRes.data.exists === true) {
                                        context.dispatch('setMatchingImageForAudio', existsRes.data)

                                    }

                                    context.dispatch('setFileUploaded', res.data)
                                })
                                .catch(() => {
                                    context.commit('setIsCheckingIfExists', false)
                                })

                            //} else {

                            //context.dispatch('setFileUploaded', res.data)
                            //}


                        })
                        .catch(() => {
                            //console.log("err", err)
                        })
                }
            })

            context.dispatch('status/updateResources', 'files', {root: true})


        },

        uploadRouteDescriptionImage(context, payload) {
            //console.log("# uploadRouteDescriptionImage", payload)

            if (typeof context.state.validMimeTypes[6] === 'undefined') {
                //console.error('Missing valid mimetype');
                return;
            }

            context.commit('setIsUploading', true)

            let validExtensions = [];
            //let validFiles = [];
            let uniqueExtensions = [];
            let validMimeTypes = Object.keys(context.state.validMimeTypes[6].mimeTypes).map((mt) => {
                let exts = context.state.validMimeTypes[6]['mimeTypes'][mt];
                validExtensions = validExtensions.concat(exts);

                return mt;
            })

            validExtensions.forEach((ve) => {
                let i = uniqueExtensions.findIndex((ue) => {
                    return ue == ve;
                })

                if (i == -1) {
                    uniqueExtensions.push(ve);
                }
            })

            validExtensions = uniqueExtensions;

            payload = Array.from(payload);
            let f = payload[0];

            let foundMimetype = validMimeTypes.find((t) => {
                return t === f.type;
            })

            let duplicate = context.state.filesToUpload.find((ftu) => {
                return f.name === ftu.name;
            })

            if (duplicate) {
                f.error = {
                    text: context.rootGetters['translate/translater']
                        .__('File already exists', 'fileErrors'), type: 'duplicate'
                }
            }

            if (!foundMimetype) {
                f.error = {
                    text: context.rootGetters['translate/translater']
                        .__('Only valid filetypes are {0}',
                            'fileErrors',
                            validExtensions.join(', ')
                        ), type: 'filetype'
                }
            }

            context.commit('setFilesToUpload', [f])
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'authorization': localStorage.getItem('authorization')

                },

                onUploadProgress: (e) => {
                    let progress = e.loaded / e.total * 100;
                    progress = parseInt(progress);
                    f.progress = progress;

                    //window.vm.$emit('uploadProgress');

                }

            };

            if (typeof f.error === 'undefined') {
                let data = new FormData();
                data.append('file', f)
                data.append('dir', context.rootGetters['routes/route'].name)
                data.append('type', 6);
                axios.post(APIURL + 'checkpoints/upload', data, config)
                    .then((res) => {

                        window.vm.$emit('routeDescriptionImageUploaded', res.data)
                        context.dispatch('status/updateResources', 'files', {root: true})
                    })
                    .catch(() => {
                        //console.log("##### err", err)
                    })
            }


        },

        upload(context, payload) {


            let t = context.rootGetters['checkpoints/newTask'];

            if (typeof context.state.validMimeTypes[t.type] === 'undefined') {
                //console.error('Missing valid mimetype');
                return;
            }

            context.commit('setIsUploading', true);

            /*let validExtensions = [];
            //let validFiles = [];
            let uniqueExtensions = [];
            let validMimeTypes = Object.keys(context.state.validMimeTypes[t.type].mimeTypes).map((mt) => {
                let exts = context.state.validMimeTypes[t.type]['mimeTypes'][mt];
                validExtensions = validExtensions.concat(exts);

                return mt;
            })

            validExtensions.forEach((ve) => {
                let i = uniqueExtensions.findIndex((ue) => {
                    return ue == ve;
                })

                if (i == -1) {
                    uniqueExtensions.push(ve);
                }
            })

            validExtensions = uniqueExtensions;*/

            /* se oli tassa */

            const {validExtensions, validMimeTypes} =  getValidExtensions(t.type, context.state.validMimeTypes )

            payload = Array.from(payload);
            payload.forEach((f) => {


                let foundMimetype = validMimeTypes.find((t) => {
                    return t === f.type;
                })

                let duplicate = context.state.filesToUpload.find((ftu) => {
                    return f.name === ftu.name;
                })

                if (duplicate) {
                    f.error = {
                        text: context.rootGetters['translate/translater']
                            .__('File already exists', 'fileErrors'), type: 'duplicate'
                    }
                }

                if (!foundMimetype) {
                    f.error = {
                        text: context.rootGetters['translate/translater']
                            .__('Only valid filetypes are {0}',
                                'fileErrors',
                                validExtensions.join(', ')
                            ), type: 'filetype'
                    }
                }


            })


            context.commit('setFilesToUpload', payload)
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'authorization': localStorage.getItem('authorization')
                },


            };


            payload.forEach((f) => {

                //f = parseFileName(f)

                config.onUploadProgress = (e) => {
                    let progress = e.loaded / e.total * 100;
                    progress = parseInt(progress);
                    f.progress = progress;

                    //window.vm.$emit('uploadProgress');

                }
                if (typeof f.error === 'undefined') {
                    let data = new FormData();
                    data.append('file', f)
                    data.append('dir', context.rootGetters['routes/route'].name)
                    data.append('type', t.type);
                    axios.post(APIURL + 'checkpoints/upload', data, config)
                        .then((res) => {

                            //console.log

                            context.commit('checkpoints/addAnswer', res.data, {root: true});
                            context.commit('addUploadedFile', res.data);


                            if (context.state.uploadedFiles.length >= payload.length) {
                                context.commit('setIsUploading', false)
                                //context.commit('flushFilesToUpload');
                            }


                            context.dispatch('setFileUploaded', res.data)

                            /*if(context.state.editTask === true)
                            {
                                context.dispatch('replaceUploadedFile', f.name);
                            }*/


                        })
                        .catch(() => {
                            //console.log("err", err)
                        })
                }
            })

            context.dispatch('status/updateResources', 'files', {root: true})


        },

        cancelSeasonVideoReplace(context, payload) {
            let cancelable = context.state.filesToUpload.findIndex((f) => {
                return f.name === payload.name && f.error.type === 'duplicate'
            })
            if (cancelable > -1) {
                context.commit('remove', {i: cancelable, setDefaultSeasons: true})
            }
        },

        /*removeSeasonVideo(context, payload)
        {
            let t = context.rootGetters['checkpoints/newTask'];
            if(payload.edit === true)
            {
                t = context.rootGetters['checkpoints/editableTask'];
            }
                console.log("######### removeSeasonVideo before", context.state.filesToUpload  ,  payload.name)
                let i = context.state.filesToUpload.findIndex((f) => {
                    return f.name === payload.name && f.uploaded;
                })

                if(i > -1)
                {



                    context.commit('remove', {i: i})
                    context.commit('checkpoints/deleteAnswer', payload.name, {root:true})
                    window.vm.$emit('seasonSet')



                }


            /*axios.put(APIURL + 'checkpoints/remove', {filename: payload.name, dir: context.rootGetters['routes/route'].name, type: t.type})
            .then((res) => {
                let i = context.state.filesToUpload.findIndex((f) => {
                    return f.name === payload.name && f.uploaded;
                })

                if(i > -1)
                {



                    context.commit('remove', {i: i})
                    //context.commit('checkpoints/deleteAnswer', payload.name, {root:true})


                }
            })
            .catch((err) => {
                console.log(err);
            })*/
        //},

        replaceSeasonVideo(context, payload) {
            let newTask = context.rootGetters['checkpoints/newTask']
            if (typeof context.state.validMimeTypes[newTask.type] === 'undefined') {
                //console.error('Missing valid mimetype');
                return;
            }

            context.commit('setIsUploading', true)

            let validExtensions = [];
            //let validFiles = [];
            let uniqueExtensions = []


            let validMimeTypes = Object.keys(context.state.validMimeTypes[newTask.type].mimeTypes).map((mt) => {
                let exts = context.state.validMimeTypes[newTask.type]['mimeTypes'][mt];
                validExtensions = validExtensions.concat(exts);

                return mt;
            })

            validExtensions.forEach((ve) => {
                let i = uniqueExtensions.findIndex((ue) => {
                    return ue == ve;
                })

                if (i == -1) {
                    uniqueExtensions.push(ve);
                }
            })

            validExtensions = uniqueExtensions;


            let foundMimetype = validMimeTypes.find((t) => {
                return t === payload.type;
            })


            let existingFileIndex = context.state.filesToUpload.findIndex((f) => {
                return f.name === payload.name && typeof f.error === 'undefined';
            })

            if (existingFileIndex > -1) {

                context.commit('remove', {i: existingFileIndex, setDefaultSeasons: true});
            }


            if (!foundMimetype) {
                payload.error = {
                    text: context.rootGetters['translate/translater']
                        .__('Only valid filetypes are {0}',
                            'fileErrors',
                            validExtensions.join(', ')
                        ), type: 'filetype'
                }
            }


            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'authorization': localStorage.getItem('authorization')
                },

                onUploadProgress: (e) => {
                    let progress = e.loaded / e.total * 100;
                    progress = parseInt(progress);
                    payload.progress = progress;

                    //window.vm.$emit('uploadProgress');

                }


            };

            let data = new FormData();
            data.append('file', payload)
            data.append('dir', context.rootGetters['routes/route'].name)


            axios.post(APIURL + 'checkpoints/upload', data, config)
                .then((res) => {

                    context.dispatch('setFileUploaded', res.data)
                    context.dispatch('setIsUploading')
                    context.commit('setDefaultSeasonsForFile')
                    context.dispatch('status/updateResources', 'files', {root: true})

                })
                .catch(() => {
                    //console.log("err", err)
                })
        },

        uploadSeasonVideo(context, payload) {
            let newTask = context.rootGetters['checkpoints/newTask']
            if (typeof context.state.validMimeTypes[newTask.type] === 'undefined') {
                //console.error('Missing valid mimetype');
                return;
            }

            context.commit('setIsUploading', true)

            let validExtensions = [];
            //let validFiles = [];
            let uniqueExtensions = [];
            let validMimeTypes = Object.keys(context.state.validMimeTypes[newTask.type].mimeTypes).map((mt) => {
                let exts = context.state.validMimeTypes[newTask.type]['mimeTypes'][mt];
                validExtensions = validExtensions.concat(exts);

                return mt;
            })

            validExtensions.forEach((ve) => {
                let i = uniqueExtensions.findIndex((ue) => {
                    return ue == ve;
                })

                if (i == -1) {
                    uniqueExtensions.push(ve);
                }
            })

            validExtensions = uniqueExtensions;

            payload = Array.from(payload);
            payload.forEach((f) => {

                let foundMimetype = validMimeTypes.find((t) => {
                    return t === f.type;
                })

                let duplicate = context.state.filesToUpload.find((ftu) => {
                    return f.name === ftu.name;
                })

                if (duplicate) {
                    f.error = {
                        text: context.rootGetters['translate/translater']
                            .__('File already exists', 'fileErrors'), type: 'duplicate'
                    }
                }

                if (!foundMimetype) {
                    f.error = {
                        text: context.rootGetters['translate/translater']
                            .__('Only valid filetypes are {0}',
                                'fileErrors',
                                validExtensions.join(', ')
                            ), type: 'filetype'
                    }
                }


            })


            context.commit('setFilesToUpload', payload)
            context.dispatch('status/updateResources', 'files', {root: true})
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'authorization': localStorage.getItem('authorization')
                },


            };


            payload.forEach((f) => {


                config.onUploadProgress = (e) => {
                    let progress = e.loaded / e.total * 100;
                    progress = parseInt(progress);
                    f.progress = progress;

                    //window.vm.$emit('uploadProgress');

                }
                if (typeof f.error === 'undefined') {
                    let data = new FormData();
                    data.append('file', f)
                    data.append('dir', context.rootGetters['routes/route'].name)
                    data.append('type', newTask.type);
                    axios.post(APIURL + 'checkpoints/upload', data, config)
                        .then((res) => {


                            context.dispatch('checkpoints/addSeasonAnswer', res.data, {root: true});
                            context.commit('addUploadedFile', res.data)


                            if (context.state.uploadedFiles.length >= payload.length) {

                                //context.commit('setDefaultSeasonsForFile');
                                //console.log("sdlfkjsfdlkdfsjsfdlkjfsdlkdfsjsfdlkdfs", context.state.filesToUpload);
                                context.dispatch('setIsUploading')
                                //context.dispatch('checkpointsValidator/test', {}, {root:true})
                                context.dispatch('checkpointsValidator/validateSeasonVideoTask', undefined, {root: true})
                                    .then((valid) => {
                                        context.commit('checkpointsValidator/setValid', valid, {root: true})
                                    })
                            }


                            context.dispatch('setFileUploaded', res.data)
                            //}


                        })
                        .catch(() => {
                            //console.log("err", err)
                        })
                }
            })

            context.dispatch('status/updateResources', 'files', {root: true})

        },

        setIsUploading(context) {
            let isUploading = true;
            let files = context.state.filesToUpload;
            let validFiles = files.filter((f) => {
                return typeof f.error === 'undefined'
            });
            //console.log("########setIsUploading", validFiles.length, files.length)
            if (validFiles.length == files.length) {
                isUploading = false;
            }

            context.commit('setIsUploading', isUploading)

        },

        setFileUploaded(context, payload) {

            let uploaded = context.state.filesToUpload.findIndex((f) => {
                //return f.name == payload
                return fileTools.sanitize(f) === payload
            });

            if (uploaded > -1) {
                context.commit('setFileUploaded', uploaded)

            }
        },

        uploadSingleImageEdit(context, payload) {
            context.dispatch('uploadEdit', {
                files: payload,
                replaceMethod: 'checkpoints/replaceSingleImage'
            });
        },

        uploadSeasonVideoEdit(context, payload) {
            context.dispatch('uploadEdit', {
                files: payload,
                replaceMethod: 'checkpoints/replaceUploadedSeasonVideoFile'
            });
        },

        uploadVideoEdit(context, payload) {
            //console.log("uploadVideoEdit", payload)

            context.dispatch('uploadEdit', {
                files: payload,
                replaceMethod: 'checkpoints/replaceUploadedVideoFile'
            });
        },

        uploadImageTaskEdit(context, payload)
        {


            context.dispatch('checkpointsValidator/checkIfAnswerExists', payload, {root: true})
                .then((valid) => {
                    if(!valid) {
                        payload[0].error = {
                            text: 'Image with same name exists',
                            type: 'fileexists'
                        }


                    }
                    context.dispatch('uploadEdit', payload)

                }).catch((err) => {})
        },

        uploadAudioTaskEdit(context, payload)
        {
            context.dispatch('checkpointsValidator/checkIfAnswerExists', payload, {root: true})
                .then((valid) => {
                    if(!valid) {
                        payload[0].error = {
                            text: 'Audio file with same name exists',
                            type: 'fileexists'
                        }


                    }
                    context.dispatch('uploadEdit', payload)

                }).catch((err) => {})
        },


        uploadEdit(context, payload) {
            let t = context.rootGetters['checkpoints/editableTask'];
            if (typeof payload.files === 'undefined') {
                payload.files = payload;
            }

            if (typeof context.state.validMimeTypes[t.type] === 'undefined') {
                //console.error('Missing valid mimetype');
                return;
            }

            context.commit('setIsUploading', true)

            let validExtensions = [];
            //let validFiles = [];
            let uniqueExtensions = [];
            let validMimeTypes = payload.validMimeTypes;

            if (typeof validMimeTypes === 'undefined') {
                validMimeTypes = Object.keys(context.state.validMimeTypes[t.type].mimeTypes).map((mt) => {
                    let exts = context.state.validMimeTypes[t.type]['mimeTypes'][mt];
                    validExtensions = validExtensions.concat(exts);

                    return mt;
                })
            }

            validExtensions.forEach((ve) => {
                let i = uniqueExtensions.findIndex((ue) => {
                    return ue === ve;
                })

                if (i === -1) {
                    uniqueExtensions.push(ve);
                }
            })

            validExtensions = uniqueExtensions;

            payload.files = Array.from(payload.files);
            payload.files.forEach((f) => {

                let foundMimetype = validMimeTypes.find((t) => {
                    return t === f.type;
                })

                let duplicate = context.state.filesToUpload.find((ftu) => {
                    return f.name === ftu.name;
                })

                if (duplicate) {
                    f.error = {
                        text: context.rootGetters['translate/translater']
                            .__('File already exists', 'fileErrors'), type: 'duplicate'
                    }
                }

                if (!foundMimetype) {
                    f.error = {
                        text: context.rootGetters['translate/translater']
                            .__('Only valid filetypes are {0}',
                                'fileErrors',
                                validExtensions.join(', ')
                            ), type: 'filetype'
                    }
                }


            })

            let hasError = payload.files.find((file) => {
                return typeof file.error !== 'undefined'
            })

            /*if (hasError) {

                context.commit(
                    'checkpointsValidator/setValidEdit', false, {root: true});
            }*/


            context.commit('setFilesToUpload', payload.files)
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'authorization': localStorage.getItem('authorization')
                },


            };


            payload.files.forEach((f) => {


                config.onUploadProgress = (e) => {
                    let progress = e.loaded / e.total * 100;
                    progress = parseInt(progress);
                    f.progress = progress;

                    //window.vm.$emit('uploadProgress');

                }
                if (typeof f.error === 'undefined') {
                    let data = new FormData();
                    data.append('file', f)
                    data.append('dir', context.rootGetters['routes/route'].name)
                    data.append('type', payload.type || t.type);
                    axios.post(APIURL + 'checkpoints/upload', data, config)
                        .then((res) => {


                            //context.commit('addAnswerEdit', res.data);
                            context.commit('addUploadedFile', res.data)


                            if (context.state.uploadedFiles.length >= payload.length) {
                                context.commit('setIsUploading', false)
                                //context.commit('flushFilesToUpload');
                            }


                            context.dispatch('setFileUploaded', res.data)

                            if (typeof payload.replaceMethod === 'undefined') {
                                context.dispatch('checkpoints/replaceUploadedFile', f.name, {root: true});
                            } else {
                                //console.log(payload.replaceMethod)
                                context.dispatch(payload.replaceMethod, f.name, {root: true});
                            }


                        })
                        .catch(() => {
                            //console.log("err", err)
                        })
                }
            })

            context.dispatch('status/updateResources', 'files', {root: true})


        },


    },

    mutations: {

        setIsRemoving(state, payload) {
            //console.log("setIsRemoving", payload)
            state.isRemoving = payload
        },

        setSeasonErrors(state, payload) {
            payload.forEach((p) => {
                let found = state.filesToUpload.find((f) => {
                    return p.name == f.name;
                })

                if (found) {
                    found.season.error = translater.__('Duplicate')
                }
            })

            //console.log("setSeasonErrors", state.filesToUpload)
        },

        setSeason(state, payload) {
            let files = state.filesToUpload;
            state.filesToUpload = [];


            files[payload.found].season.value = payload.c;

            state.filesToUpload = files;


        },

        flushSeasonErrors(state) {
            let files = state.filesToUpload;
            files.forEach((f) => {
                f.season.error = undefined;
            });
        },


        setAudioTaskImageUploaded(state, payload) {
            if (typeof state.audioTaskAnswerImagesToUpload[payload] !== 'undefined') {
                state.audioTaskAnswerImagesToUpload[payload].uploaded = true;
            }
        },

        setAudioTaskAnswerImageToUpload(state, payload) {
            //state.audioTaskAnswerImagesToUpload[payload.audio] = payload.image;
            let answers = state.audioTaskAnswerImagesToUpload;
            state.audioTaskAnswerImagesToUpload = {};
            answers[payload.audio] = payload.image;
            state.audioTaskAnswerImagesToUpload = answers;

            //console.log("setAudioTaskAnswerImageToUpload", state.audioTaskAnswerImagesToUpload)
        },

        setUploadImageAnswer(state, payload) {
            let filesToUpload = state.filesToUpload;
            filesToUpload[payload.i].uploadImageAnswer = payload.value;
            //state.filesToUpload = filesToUpload;
            //window.vm.$emit('uploadImageAnswerSet')

            state.filesToUpload = [];
            state.filesToUpload = filesToUpload;
        },

        setMatchingImageForAudio(state, payload) {
            let filesToUpload = state.filesToUpload;
            filesToUpload[payload.i].matchingImage = payload.image;
            state.filesToUpload = [];


            state.filesToUpload = filesToUpload;
        },

        setIsCheckingIfExists(state, payload) {
            state.isCheckingIfExists = payload

        },

        flushFilesToUpload(state) {
            state.filesToUpload = []
            state.uploadedFiles = []
        },

        remove(state, payload) {
            let files = state.filesToUpload;
            files.splice(payload.i, 1);
            state.filesToUpload = [];

            state.filesToUpload = files;
            state.isUploading = false;

            //console.log("###############remove after", state.filesToUpload)
            state.isRemoving = false;


            //window.vm.$emit('fileRemoved', payload.setDefaultSeasons)

        },

        /*setDefaultSeasonsForFile(state)
        {


                state.filesToUpload.forEach((f, i) => {
                    //if(typeof f.season === 'undefined')d
                    //{

                    f.season = { value:i, error: undefined};

                    //}
                })
            //}

            //console.log("###########setDefaultSeasonsForFile", state.filesToUpload)

            //console.log("####setDefaultSeasonsForFile", state.filesToUpload)




        },*/

        setFileUploaded(state, payload) {
            let filesToUpload = state.filesToUpload;
            filesToUpload[payload].uploaded = true;
            filesToUpload[payload].error = undefined;
            state.filesToUpload = filesToUpload;
            state.filesToUpload = [];
            state.filesToUpload = filesToUpload;
            //window.vm.$emit("fileUploaded");
        },

        addUploadedFile(state, payload) {
            let uploadedFiles = state.uploadedFiles;
            uploadedFiles.push(payload);
            state.uploadedFiles = uploadedFiles;
        },

        setFilesToUpload(state, payload) {
            let filesToUpload = state.filesToUpload;
            filesToUpload = payload.concat(filesToUpload);
            state.filesToUpload = filesToUpload
        },

        /*replaceUploadedVideoFile(state, payload)
        {

            let editableTask = state.editableTask;
            editableTask.question.files[0].path = payload
            state.editableTask = {};
            state.editableTask = editableTask;
            state.isBeingReplaced = false;


        },*/

        setIsUploading(state, payload) {

            state.isUploading = payload
        }

    },

    getters: {

        isRemoving(state) {
            return state.isRemoving;
        },

        audioTaskAnswerImagesToUpload(state) {
            return state.audioTaskAnswerImagesToUpload;
        },

        filesToUpload(state) {
            return state.filesToUpload;
        },

        isUploading(state) {
            return state.isUploading;
        },

        validMimeTypes(state)
        {
            return state.validMimeTypes;
        }

        /*fullPath(state)
        {

            return APIURL + state.paths[state.newTask.type]
        },*/
    }
}

const getValidExtensions = (taskType, mimeTypes) => {

    return fileTools.getValidExtensions(taskType, mimeTypes)

    /*let validExtensions = [];
    //let validFiles = [];
    let uniqueExtensions = [];
    //let validMimeTypes = Object.keys(context.state.validMimeTypes[t.type].mimeTypes).map((mt) => {
    let validMimeTypes = Object.keys(mimeTypes[taskType].mimeTypes).map((mt) => {
        let exts = mimeTypes[taskType]['mimeTypes'][mt];
        validExtensions = validExtensions.concat(exts);

        return mt;
    })

    validExtensions.forEach((ve) => {
        let i = uniqueExtensions.findIndex((ue) => {
            return ue == ve;
        })

        if (i == -1) {
            uniqueExtensions.push(ve);
        }
    })

    validExtensions = uniqueExtensions;

    return {validMimeTypes, validExtensions}*/
}